export const iconList = `
	faAmbulance
	faAlignCenter
	faAngleLeft
	faAngleRight
	faArchive
	faArrowsAltV
	faArrowDown
    faArrowLeft
	faArrowRight
	faArrowRightFromBracket
	faArrowUp
	faBan
	faBarcode
	faBars
	faBell
	faBox
	faBoxOpen
	faBoxes
	faBuilding
	faBullhorn
    faCalculator
	faCalendarAlt
	faCaretDown
	faCaretRight
	faCartPlus
	faChartBar
	faChartLine
	faChartPie
	faCheck
	faCheckCircle
	faChevronDown
	faChevronRight
	faCircle
	faClipboardList
	faClock
	faCogs
	faComment
	faComments
	faCreditCard
	faCut
	faDog
	faDollarSign
	faDolly
	faExclamation
	faExclamationCircle
	faExclamationTriangle
	faEye
	faEyeSlash
	faFile
	faFileExcel
	faFileExport
	faFileImage
	faFileInvoiceDollar
	faFilePdf
	faFileWord
	faFire
	faFireAlt
    faFloppyDisk
	faGrinBeam
	faGripVertical
	faHandPaper
	faHandSparkles
	faHome
	faHospital
	faInbox
	faIndent
	faInfoCircle
    faKey
	faList
	faLock
	faMagic
	faMapMarkerAlt
	faMinus
	faMonument
	faOutdent
	faPaperPlane
	faPaw
	faPen
	faPenAlt
    faPencil
	faPenSquare
	faPencilSquareo
	faPenSquareo
	faPhone
	faPlus
	faPrint
    faQrcode
	faReply
	faSearch
	faShoppingCart
	faShuttleVan
    faSignal
	faSitemap
	faSort
	faSortDown
	faSortUp
	faSpinner
    faStarHalfStroke
	faSquare
	faTachometerAlt
	faTag
	faTasks
	faThList
	faThumbsUp
	faTimes
	faTrash
	faTrashAlt
	faTruck
	faTruckLoading
	faTruckMoving
	faUndo
	faUnlock
	faUpload
	faUser
	faUserCircle
	faUserMd
    faUserPen
    faUserPlus
	faUsers
	faUserSecret
	faWalking
    faWandMagicSparkles
	faWarehouse
`.trim().split(/\s+|,/g);